import React, { lazy, Suspense } from 'react';
import HeroSection from '../components/Home/HeroSection';

// Ekranın altında kalan bölümler ana paketten ayrılır; Hero hemen görünürken
// bunlar arka planda iner.
const ClimateSection      = lazy(() => import('../components/Home/ClimateSection'));
const ShowcaseGrid        = lazy(() => import('../components/Home/ShowcaseGrid'));
const PublicationsSection = lazy(() => import('../components/Home/PublicationsSection'));
const NewsSection         = lazy(() => import('../components/Home/NewsSection'));
const EventsSection       = lazy(() => import('../components/Home/EventsSection'));
const MezunYorumlari      = lazy(() => import('../components/Home/MezunYorumlari'));

const Home = () => {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <Suspense fallback={<div style={{ minHeight: '100vh' }} />}>
        <ClimateSection />
        <ShowcaseGrid />
        <PublicationsSection />
        <NewsSection />
        <EventsSection />
        <MezunYorumlari />
      </Suspense>
    </div>
  );
};

export default Home;
